import {ReactNode} from 'react';

import {EXTERNAL_OPEN_LICENSE_SUPPORT_REQUEST_LINK} from 'src/routes';

import {LicenseType, CustomizableTextKey} from './types';
export const LICENSE_TEXT_MAP: Record<LicenseType, Partial<Record<CustomizableTextKey, ReactNode>>> = {
  CORE: {},
  ENTERPRISE: {},
  COMMUNITY: {},
  TRIAL: {
    'license_type': 'Community Edition Trial',
    'expiration_date_supplimental_note': '(30-day Community Edition Trial)',
    'supplimental_note': (
      <span>30-day Community Edition Trial. <a
        target="_blank"
        href={EXTERNAL_OPEN_LICENSE_SUPPORT_REQUEST_LINK}
        className="LicenseTab__contact-us__link"
        rel="noreferrer"
      >Contact us</a> for a free 1-year Community Edition license.</span>
    ),

  },
} as const;
